export default {
    data: () => ({
        translations: {
            title: {
                el: "Διαχείριση Κατηγοριών",
                en: "Catalogue Categories",
                it: "Categoria Gestione"
            },
            info: {
                el: "Δημιουργήστε τις κατηγορίες του καταλόγου σας εδώ και στη συνέχεια προσθέστε τα δώρα του καταλόγου σε κάθε κατηγορία από τον κατάλογο δώρων.",
                en:
                    "Create your catalogue categories and add the catalogue gifts to each category from Gift Catalogue.",
                it: "Crea qui le categorie del tuo catalogo e poi aggiungi i regali del catalogo ad ogni categoria dal catalogo dei regali."
            },
            giftCatalog: {
                el: "Κατάλογος",
                en: "Catalog",
                it: "Catalogo"
            },
            addCategory: {
                el: "Προσθήκη Κατηγορίας",
                en: "Add Category",
                it: "Aggiungere una categoria"
            },
            editCategory: {
                el: "Επεξεργασία Κατηγορίας",
                en: "Update Category",
                it: "Aggiorna Categoria"
            },
            categoryName: {
                el: "Όνομα Κατηγορίας",
                en: "Category Name",
                it: "Nome della categoria"
            },
            fontColor: {
                el: "Χρώμα Γραμματοσειράς",
                en: "Font Colour",
                it: "Colore del carattere"
            },
            backgroundColor: {
                el: "Χρώμα Φόντου",
                en: "Backround Colour",
                it: "Colore di sfondo"
            },
            lastUploaded: {
                el: "Τελευταία μεταφόρτωση",
                en: "Last Uploaded",
                it: "Ultimo caricamento"
            },
            imageCategory: {
                el: "Εικόνα Κατηγορίας",
                en: "Image Category",
                it: "Immagine della categoria"
            },
            english: {
                el: "Αγγλικά",
                en: "English",
                it: "Inglese"
            },
            italian: {
                el: "Ιταλικά",
                en: "Italian",
                it: "Italiano"
            },
            actions: {
                el: "Ενέργειες",
                en: "Actions",
                it: "Azioni"
            },
            noData: {
                el: "Δεν υπάρχουν δεδομένα",
                en: "No data available",
                it: "Nessun dato disponibile"
            },
            update: {
                el: "Ενημέρωση",
                en: "Update",
                it: "Aggiornamento"
            },
            delete: {
                el: "Διαγραφή",
                en: "Delete",
                it: "Cancellare"
            },
            paginationText: {
                el: "από",
                en: "of",
                it: "di"
            }
        }
    })
};
